// src/pages/NotFoundPage.tsx
// Catch-all for unknown URLs. Replaces the old <Navigate to="/"> so dead links
// aren't served as a copy of the home page. CloudFront still answers 200 for
// every path (SPA fallback), so noindex is what keeps these out of search.

import React from 'react';
import { Link } from 'react-router-dom';
import { useSeo } from '../hooks/useSeo';
import '../styles/news-detail.css';

const NotFoundPage: React.FC = () => {
  useSeo({ title: 'Page not found', noindex: true });

  return (
    <div className="sl-nd-notfound">
      <h1>Page Not Found</h1>
      <p>This page doesn't exist or may have moved.</p>
      <Link to="/" className="sl-nd-back-btn">← Back to Home</Link>
    </div>
  );
};

export default NotFoundPage;
